var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NavigationView_instances, _NavigationView_rootElement, _NavigationView_contentElement, _NavigationView_init;
import ScrollSpy from '@resources/js/ui/ScrollSpy';
import ScrollFog from '@resources/js/ui/ScrollFog';
const SELECTORS = {
    nav: '.js-attraction-nav',
    fog: '.js-nav-fog',
    tracks: '.js-nav-track-section',
};
// активна зона ScrollSpy - смуга одразу під хедером, а не коли блок зʼявляється во вьюпорті
const ACTIVE_ZONE_PX = 10;
class NavigationView {
    constructor(rootElement, contentElement) {
        _NavigationView_instances.add(this);
        _NavigationView_rootElement.set(this, void 0);
        _NavigationView_contentElement.set(this, void 0);
        __classPrivateFieldSet(this, _NavigationView_rootElement, rootElement, "f");
        __classPrivateFieldSet(this, _NavigationView_contentElement, contentElement, "f");
        __classPrivateFieldGet(this, _NavigationView_instances, "m", _NavigationView_init).call(this);
    }
}
_NavigationView_rootElement = new WeakMap(), _NavigationView_contentElement = new WeakMap(), _NavigationView_instances = new WeakSet(), _NavigationView_init = function _NavigationView_init() {
    const navHeight = __classPrivateFieldGet(this, _NavigationView_rootElement, "f").clientHeight;
    const trackElements = __classPrivateFieldGet(this, _NavigationView_contentElement, "f").querySelectorAll(SELECTORS.tracks);
    if (!trackElements.length)
        return;
    trackElements.forEach(el => {
        el.style.scrollMarginTop = `${navHeight}px`;
    });
    const navElement = __classPrivateFieldGet(this, _NavigationView_rootElement, "f").querySelector(SELECTORS.nav);
    const fogElement = __classPrivateFieldGet(this, _NavigationView_rootElement, "f").querySelector(SELECTORS.fog);
    const bottomMargin = window.innerHeight - navHeight - ACTIVE_ZONE_PX;
    new ScrollSpy(navElement, trackElements, {
        rootMargin: `-${navHeight}px 0px -${bottomMargin}px`,
    });
    new ScrollFog(navElement, fogElement);
};
export default NavigationView;
